
export const areDistinct = (arr: string[]) => {
    const n = arr.length;
    const s = new Set();
    for (let i = 0; i < n; i++) {
        s.add(arr[i]);
    }
    return s.size == arr.length;
};


export const getSecondUniqueFromList = (values: string[]) => {
    const uniqueArray: string[] = [];
    values.forEach(item => {
        if (uniqueArray.includes(item)) {
            //do nothing
        } else {
            uniqueArray.push(item);
        }
    });
    return uniqueArray.length > 1 ? uniqueArray[1] : undefined;
};

export const isStringGuard = (item: string | undefined): item is string => {
    return !!item;
};

export const getFirstDuplicateFromList = (values: (string | undefined)[]) => {
    const uniqueElements = new Set();
    const duplicates: string[] = [];

    values.forEach(item => {
        if(item){
            if (uniqueElements.has(item)) {
                duplicates.push(item);
            } else {
                uniqueElements.add(item);
            }
        }
    });
    return duplicates.length ? duplicates[0] : undefined;
};
